<div bsModal #lgModal class="modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
	 aria-hidden="true">
	<div class="modal-dialog modal-sm">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" (click)="hideModal()" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">{{heading | translate}}</h4>
			</div>
			<div class="modal-body">
				<ng-content></ng-content>
			</div>
		</div>
	</div>
</div>
